import React, { useState } from "react"
import { useParams } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import { Card, CardBody } from "reactstrap"
import ColdCallForm from "./ColdCallForm"

const EditColdCall = () => {
  const { id } = useParams()

  const [formData, setFormData] = useState({
    name: "John Smith",
    email: "john@gmail.com",
    country: "USA",
  })

  const handleSubmit = () => {
    console.log("Edit Cold Call:", id, formData)
  }

  return (
    <div className="page-content">
      <Breadcrumb
        title="Cold Calling Management"
        breadcrumbItem="Edit Contact"
      />
      <Card>
        <CardBody>
          <ColdCallForm
            formData={formData}
            setFormData={setFormData}
            onSubmit={handleSubmit}
          />
        </CardBody>
      </Card>
    </div>
  )
}

export default EditColdCall
